import { useContext, useEffect, useRef } from "react";
import { useMutation } from "@apollo/client";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { APPROVE_CONVERSATION } from "../../../graphql/mutations/DirectMessageContext";
import { setConversations as actionSetConversations } from "../../../actions";
import { useMessagingContext } from "../../../hooks/Messaging";
import { useDispatch } from "react-redux";

const ApproveConversation = ({ conversation }) => {
  const { conversations, selectConversation } = useMessagingContext();
  const [approveConversation, { data, loading, error }] = useMutation(APPROVE_CONVERSATION);
  const dispatch = useDispatch();
  const hasUpdated = useRef(false);

  const handleApprove = () => {
    approveConversation({
      variables: {
        conversationId: conversation.directMessageConversationId,
      },
    });
  };

  useEffect(() => {
    const updated = data?.directMessageContext?.approveConversation;
    if (updated?.directMessageConversationId && !hasUpdated.current) {
      hasUpdated.current = true;

      const updatedConversations = conversations.map(c =>
        c.directMessageConversationId === updated.directMessageConversationId
          ? { ...c, ...updated }
          : c
      );

      dispatch(actionSetConversations({ items: updatedConversations }));
      selectConversation(updated.directMessageConversationId);
    }
  }, [data, dispatch, conversations, selectConversation]);

  const memberName = conversation?.members?.[0]?.name || "Användare";

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-end",
        position: "relative",
        height: "100%",
        pb: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          px: 3,
          py: 2,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          gap: 2,
          bgcolor: "background.paper",
        }}
      >
        <Typography>
          <FormattedMessage id="messaging.approve.request" values={{ memberName }} />
        </Typography>

        <Stack direction="row" spacing={1}>
          <Button color="error" variant="outlined">
            <FormattedMessage id="btn.no" />
          </Button>

          <Button onClick={handleApprove} disabled={loading} variant="contained" color="primary">
            <FormattedMessage id={loading ? "btn.approving" : "btn.accept"} />
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default ApproveConversation;
